/* tslint:disable */

/**
 */
export class MinMaxProductChart2D {
    minTempStep?: number;
    maxTempStep?: number;
    minTemperature?: number;
    maxTemperature?: number;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/min-max-product-chart-2d.ts